import { render, staticRenderFns } from "./dialog-footer.vue?vue&type=template&id=ca4cfffa&"
import script from "./dialog-footer.vue?vue&type=script&lang=ts&"
export * from "./dialog-footer.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports